import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import LightRays from '../game/LightRays';
import Sub from '../game/Sub';
import WordController from '../game/WordController';
import gameData from '../gameData';
import NavBar from '../ui/NavBar';
import UIAssetKeys from '../UIAssetKeys';
import Title from './Title';
import { allWords, firstGrade, nouns, prePrimer, primer, secondGrade, thirdGrade } from '../game/WordBank';

export default class LevelBase extends Phaser.Scene {
  init() {
    this.bg = null;

    this.dust = [];
    this.dTweens = [];

    /** @type {Phaser.Tweens.Tween[]} */
    this.doodTweens = [];

    this.sub = null;

    /** @type {LightRays} */
    this.lights = null;
    this.navBar = null;

    this.words = null;

    if (gameData.config.levelWordBank.length === 0) {
      if (gameData.config.gameMode === 1) gameData.config.levelWordBank = prePrimer.slice();
      else if (gameData.config.gameMode === 2) gameData.config.levelWordBank = primer.slice();
      else if (gameData.config.gameMode === 3) gameData.config.levelWordBank = firstGrade.slice();
      else if (gameData.config.gameMode === 4) gameData.config.levelWordBank = secondGrade.slice();
      else if (gameData.config.gameMode === 5) gameData.config.levelWordBank = thirdGrade.slice();
      else if (gameData.config.gameMode === 6) gameData.config.levelWordBank = allWords.slice();
      else if (gameData.config.gameMode === 7) gameData.config.levelWordBank = nouns.slice();
    }
  }

  create() {
    gameData.config.gameOver = false;
    gameData.config.gamePaused = false;

    this.createNextScene();

    this.createBackground();
    this.createLights();
    this.createNav();
    this.createSub();
    this.createDust();
    this.createWord();

    this.input.on(Phaser.Input.Events.GAME_OUT, (time, event) => {
      if (event instanceof MouseEvent) { this.input.manager.onMouseUp(event); }
    });
  }

  createNextScene () {
    this.nextLvlCont = this.add.container();
  }

  createBackground () {
    this.bg = ABCyaPhaser.Images.addImage(0,0, `${gameData.config.level + 3}_Level ${gameData.config.level}/Lvl${gameData.config.level}_Bkgd`, this).setOrigin(0);
  }

  createLights () {
    this.lights = new LightRays(this);
  }

  createNav () {
    this.navBar = new NavBar(this);
    this.add.existing(this.navBar);
  }

  createSub () {
    this.sub = new Sub(this);
  }

  createDust () {
    for (let i = 0; i < 50; i++) {
      const randX = Phaser.Math.Between(0, this.scale.width);
      const randY = Phaser.Math.Between(0, this.scale.height);
      const randAdj = Phaser.Math.Between(-20, 20);
      const randAlpha = Phaser.Math.FloatBetween(.2, 1);
      const randScale = Phaser.Math.FloatBetween(.2, 1);
      const randTime = Phaser.Math.Between(3000, 6000);

      const dust = ABCyaPhaser.Images.addImage(randX, randY, UIAssetKeys._3_Level_Assets_Common_DustMote, this).setScale(randScale)
        .setAlpha(0);

      ABCyaPhaser.Tweens.addTween(dust, 1000, { alpha: randAlpha }, Phaser.Math.Easing.Linear);
      const dT = ABCyaPhaser.Tweens.addTween(dust, randTime, { y: randY + randAdj, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Sine.InOut);

      this.dust.push(dust);
      this.dTweens.push(dT);
    }
  }

  createWord () {
    this.words = new WordController(this);
    this.add.existing(this.words);
  }

  pauseGame () {
    this.words.disableMasks();
    this.sub.disableButtons();
  }

  resumeGame () {
    this.words.enableMasks();
    this.sub.enableButtons();
  }

  goHome () {
    this.fullClean();

    this.scene.start(Title.KEY);
  }

  fullClean () {
    this.tweens.killAll();

    for (let d = 0; d < this.dust.length; d++) {
      this.dust[d].destroy();
    }
    this.dust = [];

    this.bg.destroy();

    this.words.cleanUp();
    this.words.destroy();

    this.sub.cleanUp();
    this.sub.destroy();

    this.lights?.cleanUp();
    this.lights?.destroy();

    this.navBar.cleanUp();
    this.navBar.destroy();
  }

  cleanUp () {
    for (let d = 0; d < this.dust.length; d++) {
      this.tweens.killTweensOf(this.dust[d]);
      this.dTweens[d]?.stop();
      this.dust[d].destroy();
    }
    this.dust = [];

    this.bg.destroy();

    this.sub.destroy();

    this.lights?.cleanUp();
    this.lights?.destroy();

    this.navBar.cleanUp();
    this.navBar.destroy();
  }
}